export default __webpack_public_path__ + "static/built-to-last-8056ea2e6fb541f43aaff6360ca1cf6c.mp4";